import '@aha-app/moment-fquarter';
import { dateFiscal } from './dateFns';

export const FISCAL_YEAR_FORMATS = {
  SINGLE_YEAR_QUARTER_LAST: 'single_year_quarter_last', // FY21 Q2
  SINGLE_YEAR_QUARTER_FIRST: 'single_year_quarter_first', // Q2 FY21
  BOTH_YEARS_QUARTER_LAST: 'both_years_quarter_last', // 2020/21 Q2
  BOTH_YEARS_QUARTER_FIRST: 'both_years_quarter_first', // Q2 2020/21
};

// Formats a date into a fiscal quarter string based on the given fiscal month and format.
// Duplicates some logic from lib/core_ext/fiscal_quarter_ext.rb and app/models/account.rb#fiscal_quarter_string
//
// Usage:
//   dateToFiscalQuarterString(date)
//   dateToFiscalQuarterString(date, { fiscalMonth: 6 })
//   dateToFiscalQuarterString(date, { format: FISCAL_YEAR_FORMATS.BOTH_YEARS_QUARTER_LAST })
//
// Options:
//   fiscalMonth: Month of the year when the fiscal year starts (1 to 12)
//   format: The desired fiscal year format. See FISCAL_YEAR_FORMATS
//
// ex: dateToFiscalQuarterString(Date.parse('2021-10-26', { fiscalMonth: 11 }))
//     => 'FY21 Q4'
export function dateToFiscalQuarterString(
  date,
  {
    format = FISCAL_YEAR_FORMATS.SINGLE_YEAR_QUARTER_LAST,
    fiscalMonth = 1, // 1 - January to 12 - December
  } = {}
) {
  const { quarter } = dateFiscal(date, { fiscalMonth });

  // nextYear is null when the fiscalMonth is 1 (January)
  const yearString = dateToFiscalYearString(date, { fiscalMonth, format });

  switch (format) {
    case FISCAL_YEAR_FORMATS.SINGLE_YEAR_QUARTER_LAST:
    case FISCAL_YEAR_FORMATS.BOTH_YEARS_QUARTER_LAST:
      return `${yearString} Q${quarter}`;
    case FISCAL_YEAR_FORMATS.SINGLE_YEAR_QUARTER_FIRST:
    case FISCAL_YEAR_FORMATS.BOTH_YEARS_QUARTER_FIRST:
      return `Q${quarter} ${yearString}`;
    default:
      throw new Error(`Unknown fiscal year format "${format}"`);
  }
}

// Formats a date into a fiscal year string based on the given fiscal month and format.
//
// Usage:
//   dateToFiscalYearString(date)
//   dateToFiscalYearString(date, { fiscalMonth: 6 })
//   dateToFiscalYearString(date, { format: FISCAL_YEAR_FORMATS.BOTH_YEARS_QUARTER_LAST })
//
// Options:
//   fiscalMonth: Month of the year when the fiscal year starts (1 to 12)
//   format: The desired fiscal year format. See FISCAL_YEAR_FORMATS
//
// ex: dateToFiscalYearString(Date.parse('2021-10-26', { fiscalMonth: 11 }))
//     => 'FY21'
export function dateToFiscalYearString(
  date,
  {
    format = FISCAL_YEAR_FORMATS.SINGLE_YEAR_QUARTER_LAST,
    fiscalMonth = 1, // 1 - January to 12 - December
  } = {}
) {
  const { year, nextYear } = dateFiscal(date, { fiscalMonth });

  switch (format) {
    case FISCAL_YEAR_FORMATS.SINGLE_YEAR_QUARTER_LAST:
    case FISCAL_YEAR_FORMATS.SINGLE_YEAR_QUARTER_FIRST:
      return nextYear ? `FY${nextYear % 100}` : `FY${year % 100}`;
    case FISCAL_YEAR_FORMATS.BOTH_YEARS_QUARTER_LAST:
    case FISCAL_YEAR_FORMATS.BOTH_YEARS_QUARTER_FIRST:
      return nextYear ? `${year}/${nextYear % 100}` : year.toString();
    default:
      throw new Error(`Unknown fiscal year format "${format}"`);
  }
}
